export const SET_CUSTOMER_PROPERTIES = 'SET_CUSTOMER_PROPERTIES'

export const setCustomerProperties = (val: $TSFixMe) => ({
  type: SET_CUSTOMER_PROPERTIES,
  val,
})
